const hasFinalConsonant = (word) => {
  const lastChar = word.charAt(word.length - 1);
  const charCode = lastChar.charCodeAt(0);

  // 1. 순수 한글(가~힣)인 경우
  if (charCode >= 0xAC00 && charCode <= 0xD7A3) {
    return (charCode - 0xAC00) % 28 > 0;
  }

  // 2. 숫자인 경우 (1, 3, 6, 7, 8, 0 은 받침이 있음: 일, 삼, 육, 칠, 팔, 영)
  if (/[0-9]/.test(lastChar)) {
    return ['1', '3', '6', '7', '8', '0'].includes(lastChar);
  }

  // 3. 영문 알파벳인 경우 (L, M, N, R 은 받침 발음 [엘, 엠, 엔, 알] 이 있음)
  if (/[a-zA-Z]/.test(lastChar)) {
    return ['l', 'm', 'n', 'r'].includes(lastChar.toLowerCase());
  }

  // 기본값: 받침 없음으로 간주
  return false;
};

const isFinalConsonantRieul = (word) => {
  const lastChar = word.charAt(word.length - 1);
  const charCode = lastChar.charCodeAt(0);
  
  // 1. 순수 한글(가~힣)인 경우
  if (charCode >= 0xAC00 && charCode <= 0xD7A3) {
    return (charCode - 0xAC00) % 28 === 8;
  }

  // 2. 숫자인 경우 (1, 7, 8 은 ㄹ 받침 있음: 일, 칠, 팔)
  if (/[0-9]/.test(lastChar)) {
    return ['1', '7', '8'].includes(lastChar);
  }

  // 3. 영문 알파벳인 경우 (L, R 은 ㄹ 받침 [엘, 알]  있음)
  if (/[a-zA-Z]/.test(lastChar)) {
    const lower = lastChar.toLowerCase();
    return lower === 'l' || lower === 'r';
  }

  // 기본값: ㄹ 받침 없음
  return false;

};

export const getParticle = (word, type = '을/를') => {
  if(!word || typeof word !== 'string') {
    return '';
  }

  switch (type) {
    case '을/를':
      return hasFinalConsonant(word) ? '을' : '를';
    case '이/가':
      return hasFinalConsonant(word) ? '이' : '가';
    case '은/는':
      return hasFinalConsonant(word) ? '은' : '는';
    case '과/와':
      return hasFinalConsonant(word) ? '과' : '와';
    case '아/야':
      return hasFinalConsonant(word) ? '아' : '야';
    case '으로/로':
      return (hasFinalConsonant(word) && !isFinalConsonantRieul(word)) ? '으로' : '로';
    default:
      return '';
  }
}

export const attachParticle = (word, type = '을/를') => {
  const particle = getParticle(word, type);
  return `${word}${particle}`;
}